module.exports = __webpack_public_path__ + "img/plus.4bb7d85f.svg";